import { createContext } from "react";

export const ActiveFarmContext = createContext();
